export default __webpack_public_path__ + "static/media/dispenser-1.e4200f4e.svg";